/**
 * CUSTOM
 * This code has been developed for this solution.
 */
import { CategoryQueryData } from "../../core/models/Category";
import NetworkServiceFactory from "../../core/services/network/NetworkService";
import { DEFAULT_QUERY_DATA } from "../../core/services/network/NetworkTypes";
import { useCategoriesContext } from "./CategoriesContext";

const useCategoriesActions = () => {
  const {
    setCategoriesResponseData,
    setCategoriesLoading,
    setSelectedCategory,
    setCategoriesError,
  } = useCategoriesContext();

  const dispatchGetCategories = async (
    query: CategoryQueryData = DEFAULT_QUERY_DATA()
  ) => {
    const networkService = NetworkServiceFactory.shared;
    try {
      const data = await networkService.getCategories();
      setCategoriesResponseData(data);
      setCategoriesError(undefined);
      return data;
    } catch (e: any) {
      setCategoriesError(e);
    } finally {
      setCategoriesLoading(false);
    }
  };

  const dispatchCleanCategoriesContext = () => {
    setCategoriesResponseData(undefined);
    setCategoriesError(undefined);
    setSelectedCategory(undefined);
  };

  return {
    dispatchGetCategories,
    dispatchCleanCategoriesContext,
  };
};

export { useCategoriesActions };
